module.exports = __webpack_public_path__ + "media/landing_page/shoppers-shopper-0-af7c5a57.jpg";